// extracted by mini-css-extract-plugin
export default {"mainChart":"Skeleton-module__mainChart--LZmJ8","title":"Skeleton-module__title--BJNzH","subtitle":"Skeleton-module__subtitle--QFOQv"};